import React from 'react';
import { Box } from '@mui/material';
import * as styles from './styles';

function TogglePill({ label, active, onClick }) {
    return (
        <Box
            component="button"
            onClick={onClick}
            aria-pressed={active}
            sx={styles.pill(active)}
        >
            {label}
        </Box>
    );
}

export default TogglePill;
